// src/llmchatbot/footer/Footer.js
import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-content">
                <div className="copyright">
                    Copyright© 2024 TheRanjana. All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default Footer;